
import React, { useState } from 'react';
import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import CombinedStatisticsChart1 from "../../components/ecommerce/StatisticsChart1";
import CombinedStatisticsChart2 from "../../components/ecommerce/Statics2";
import QuickActionMenu from '../../components/QuickActionMenu';
import TopUpModal from '../Products/RechargeTopup/components/TopUpModal';
import SocialActivationModal from '../Products/socialList/components/SocialActivationModal';
import BundleActivationModal from '../Products/productList/components/BundleActivationModal';
import TransferModal from '../wallet/stockTransferToDownlineAgents/components/TransferModal';
import ReverseStockModal from '../Stock/RequestToReverseStock/Components/ReverseStockModal';

export default function Home() {
  const [modalStates, setModalStates] = useState({
    topup: false,
    social: false,
    bundle: false,
    transfer: false,
    reverse: false,
  });

  const handleQuickAction = (actionId) => {
    setModalStates(prev => ({ ...prev, [actionId]: true }));
  };

  const closeModal = (modalName) => {
    setModalStates(prev => ({ ...prev, [modalName]: false }));
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 p-4 md:gap-6">
        <div className="col-span-12 space-y-6 2xl:col-span-12">
          <EcommerceMetrics />
        </div>
        <div className="col-span-12">
          <CombinedStatisticsChart1 />
        </div>
        <div className="col-span-12">
          <CombinedStatisticsChart2 />
        </div>
      </div>


      <QuickActionMenu onAction={handleQuickAction} />

      <TopUpModal
        open={modalStates.topup}
        onClose={() => closeModal('topup')}
        onSuccess={() => closeModal('topup')}
      />

      <SocialActivationModal
        open={modalStates.social}
        onClose={() => closeModal('social')}
        onSuccess={() => closeModal('social')}
      />

      <BundleActivationModal
        open={modalStates.bundle}
        onClose={() => closeModal('bundle')}
        onSuccess={() => closeModal('bundle')}
      />

      <TransferModal
        open={modalStates.transfer}
        onClose={() => closeModal('transfer')}
        onSuccess={() => closeModal('transfer')}
      />

      <ReverseStockModal
        open={modalStates.reverse}
        onClose={() => closeModal('reverse')}
        onSubmit={(formData) => {
          closeModal('reverse');
        }}
        isLoading={false}
        retailers={[]}
      />
    </>
  );
}